import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { apiGet } from '../../generic/Api_Functions'
import { TextField, MenuItem, Grid } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import SmartSelect from '../../generic/smartSelect/SmartSelect'
import { PrecisionManufacturing, GridView } from '@mui/icons-material'

const SensorsActuatorsComponentsProperties = (props) => {
  const { ioElementSet, setSaveDisabled, editMode, setIoElementSet } = props
  const [ioElementSetTypes, setIoElementSetTypes] = useState([])
  const [devices, setDevices] = useState([])
  const [requiredName, setRequiredName] = useState(false)
  const { t_ } = useSmartTranslation()

  useEffect(() => {
    const fetchData = async () => {
      const ioElementSetTypeDBs = await apiGet('ioElementSetTypes')
      const deviceDB = await apiGet('devicesBasicData')
      const deviceGroupsDB = await apiGet('deviceGroups/simple')
      setIoElementSetTypes(ioElementSetTypeDBs)
      setDevices([
        ...deviceDB.map(device => ({ ...device, group: false })),
        ...deviceGroupsDB.map(group => ({ ...group, group: true }))
      ])
    }

    fetchData()
  }, [])

  const handleNameChange = (event) => {
    if (event.target.value === '') {
      setRequiredName(true)
      setSaveDisabled(true)
    } else {
      setRequiredName(false)
      setSaveDisabled(false)
    }
  }

  const assetSelectableOptions = useMemo(() => {
    return devices.map(option => option.name)
  }, [devices])

  const selectedAssetValues = useMemo(() => {
    const values = ioElementSet.devices ?? (ioElementSet.device ? [ioElementSet.device] : [])
    if (!Array.isArray(values)) return []
    return values.map(option => typeof option === 'object' ? option?.name : option).filter(Boolean)
  }, [ioElementSet.devices, ioElementSet.device])

  const resolveAssetOptionIcon = useCallback((option) => {
    const optionObject = (option !== null && typeof option === 'object')
      ? option
      : devices.find(device => device.name === option)

    return optionObject?.group ? <GridView /> : <PrecisionManufacturing />
  }, [devices])

  return (
    <Grid container direction='row' spacing={3} columns={{ xs: 1, sm: 4, md: 8, lg: 12 }}>
      <Grid item xs={2}>
        <TextField
          label={t_('Code')}
          fullWidth
          disabled
          value={ioElementSet.code}
          InputLabelProps={{
            shrink: !!ioElementSet.code
          }}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          label={t_('Name')}
          fullWidth
          value={ioElementSet.name}
          required
          error={requiredName}
          onChange={event => {
            setIoElementSet({ ...ioElementSet, name: event.target.value })
            handleNameChange(event)
          }}
          disabled={!editMode}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={t_('Description')}
          fullWidth
          value={ioElementSet.description}
          InputLabelProps={{
            shrink: !!ioElementSet.description
          }}
          onChange={event => {
            setIoElementSet({ ...ioElementSet, description: event.target.value })
          }}
          disabled={!editMode}
        />
      </Grid>
      <Grid item xs={2}>
        <SmartSelect
          label={t_('Asset')}
          multiple
          disableClearable={false}
          value={selectedAssetValues}
          selectableOptions={assetSelectableOptions}
          onChange={(newSelectedValues) => {
            const selectedDevices = (newSelectedValues ?? [])
              .map((value) => devices.find(device => device.name === value))
              .filter(Boolean)
            setIoElementSet({ ...ioElementSet, devices: selectedDevices ?? [], device: null })
          }}
          iconFunction={resolveAssetOptionIcon}
          disabled={!editMode}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          select
          fullWidth
          label={t_('Type')}
          required
          value={ioElementSet.ioElementSetType?.code || ''}
          onChange={event => {
            const selectedType = ioElementSetTypes.find(type => type.code === event.target.value)
            setIoElementSet({ ...ioElementSet, ioElementSetType: selectedType })
          }}
          disabled={!editMode}
        >
          {ioElementSetTypes.map((ioElementSetType) => (
            <MenuItem value={ioElementSetType.code} key={ioElementSetType.id}>
              {ioElementSetType.code}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  )
}

export default SensorsActuatorsComponentsProperties
